import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'tonteppich-equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss']
})
export class EquipmentComponent {

  constructor(private transloco: TranslocoService) { }

  public getTranslation(key: string) {
    if (this.transloco.getTranslation().get(this.transloco.getActiveLang())) {
      return this.transloco.getTranslation().get(this.transloco.getActiveLang())[key]
    } return [];
  }
}
